import { Link } from "react-router-dom";
import { BRAND } from "../lib/brand";

/** Reusable brand mark. variant="full" shows logo + name+tagline; "icon" is logo only. */
export default function Logo({ variant = "full", to = "/", dark = true, className = "", testId = "brand-logo" }) {
  const tone = dark ? "text-white" : "text-charcoal";
  const subTone = dark ? "text-gold-300" : "text-emerald2";

  const content = (
    <div className={`flex items-center gap-3 ${className}`} data-testid={testId}>
      <img
        src={BRAND.logoUrl}
        alt={BRAND.name}
        className="h-12 w-12 md:h-14 md:w-14 object-contain"
      />
      {variant === "full" && (
        <div className="leading-tight">
          <div className={`font-serif text-lg md:text-xl tracking-tight ${tone}`}>{BRAND.name}</div>
          <div className={`text-[10px] uppercase tracking-[0.26em] mt-1 font-semibold ${subTone}`}>
            Powered by AsterPOS Corp
          </div>
        </div>
      )}
    </div>
  );

  if (!to) return content;
  return <Link to={to} className="inline-flex items-center" aria-label={BRAND.name}>{content}</Link>;
}
